import {NgModule} from '@angular/core';
import {MatButtonModule, MatIconModule} from '@cdk/angular/material';

import {NavbarHorizontalStyle1Component} from './style-1.component';
import { CdkNavigationComponent } from '@cdk/components/navigation/navigation.component';

@NgModule({
    imports: [
    MatButtonModule,
    MatIconModule,
    CdkNavigationComponent,
    NavbarHorizontalStyle1Component
],
    exports: [
        NavbarHorizontalStyle1Component
    ]
})
export class NavbarHorizontalStyle1Module {
}
